import axios from "axios";
import { errorMessage } from "./toastifyShowMessage";
import { HandleServicesError } from "./swalModal";
import { clearApp, getLocalStorage, setAuthorization, setToken } from "./services";
import { _ckey } from "../address";
import { delay } from "./tools";
// ساختار دریافت و پست کردن دیتا
const QueryAPI = async ({ url = "", parameters = {}, type = "post", contentType = "application/json; charset=utf-8", signal }) => {
	let response = null;
	setAuthorization(getLocalStorage(_ckey.token));
	try {
		const apiUrl = process.env.REACT_APP_API_KEY + url;
		if (type === "post") {
			response = await axios.post(apiUrl, parameters, {
				signal,
				timeout: 30000,
				headers: {
					"Content-Type": contentType,
				},
			});
		} else {
			response = await axios.get(apiUrl, { signal, timeout: 30000 });
		}
		if (response.data.HasError) {
			errorMessage(response.data.Message);
			return null;
		}
	} catch (error) {
		if (error?.response?.status === 401) {
			console.error("An error occurred", error.code);
			clearApp();
			// HandleServicesError();
			window.location.href = "/";
		} else {
			if (process.env.REACT_APP_DOMAIN === "dealer") {
				errorMessage(
					<div dir="ltr" style={{ textAlign: "left" }}>
						{error?.code} <br />
						{error?.message} <br />
						{error?.config?.url} <br />
						<div dir="ltr">{JSON.stringify(JSON.parse(error?.config?.data), undefined, 2)}</div>
					</div>,
				);
			} else {
				// errorMessage(
				//   <div>
				//     {error?.code} <br />
				//     {error?.message} <br />
				//     {error?.config?.url} <br />
				//   </div>,
				// );
				errorMessage("درحال حاضر سرویس در دسترس نمی‌باشد");
			}
		}
	}
	return response ? response.data : null;
};
export const useAPIPublic = () => {
	//لاگین به سرویس
	const login = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/Login", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت توکن
	const createApiTokenBySession = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CreateAPITokenBySession", parameters: parameters });
		return response ? response?.Result : null;
	};
	//دریافت درصد مالیات
	const queryTaxPercent = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryTaxPercent", type: "GET" });
		return response ? response.Result : null;
	};
	//دریافت توکن برای دسترسی به کیف پول
	const accessAsanWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/AccessAsanWallet", parameters: parameters });
		return response ? response?.Result : null;
	};
	//ارسال کد OTP
	const sendOTPCodeAsync = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/SendOTPCodeAsync", parameters: parameters });
		return response ? response?.Result : null;
	};
	//ارسال مجدد کد OTP
	const resendOTPCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/ResendOTPCode", parameters: parameters });
		return response ? response?.Result : null;
	};
	//تایید کد OTP
	const confirmOTPCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/ConfirmOTPCode", parameters: parameters });
		return response ? response : null;
	};
	//دریافت اطلاعات مربوط به کاربر
	const queryCurrentUser = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryCurrentUser", type: "Get" });
		return response ? response?.Result : null;
	};
	//جنسیت
	const queryGender = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryGender", type: "GET" });
		return response ? response.Result : null;
	};
	//لیست استان ها
	const queryActiveProvince = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveProvince", type: "GET" });
		return response ? response.Result : null;
	};
	// دریافت اطلاعات استان و شهر
	const queryCityByCityId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryCityByCityId?cityid=" + parameters, type: "GET" });
		return response ? response.Result : null;
	};
	//لیست شهر ها براساس استان
	const queryActiveCityByProvinceId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCityByProvinceId?provinceid=" + parameters, type: "GET" });
		return response ? response.Result : null;
	};
	//resetPassword
	const resetPassword = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/resetPassword", parameters: parameters });
		return response ? response : null;
	};

	//بارگذاری فایل
	const addDocument = async (request, queryString) => {
		let response = null;
		response = await QueryAPI({
			url: `/public/Document/AddDocument?doctype=${queryString}`,
			parameters: request,
			contentType: "multipart/form-data",
		});
		await delay();
		return response ? response : null;
	};
	//دریافت فایل بارگذاری شده
	const getDocument = async (request) => {
		let response = null;
		response = await QueryAPI({ url: `/public/Document/GetDocument?docid=${request}`, type: "GET" });
		return response ? response.Result : null;
	};
	//دریافت لیست کیف پول
	const queryWalletType = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryWalletType", type: "Get" });
		return response ? response.Result : null;
	};

	//ارسال OTP
	const queryOTPIsRequired = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryOTPIsRequired", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت دلایل تعویض سیم کارت
	const querySimSwapReason = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QuerySimSwapReason", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت لیست مدارک
	const queryCertType = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryCertType", type: "GET" });
		return response ? response.Result : null;
	};

	//دریاف لیست کشورها
	const queryActiveCountry = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCountry", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت زبان
	const queryActiveLanguage = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveLanguage", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت حداقل برداشت
	const queryMinimumAmountGetCashFromWallet = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryMinimumAmountGetCashFromWallet", type: "GET" });
		return response ? response.Result : null;
	};

	//برداشت از اعتبار
	const withdrawUserWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/WithdrawUserWallet", parameters: parameters });
		return response ? response.Result : null;
	};

	//رفرش توکن
	const refreshToken = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/RefreshToken", parameters: parameters });
		return response ? response.Result : null;
	};
	//بروزرسانی کلمه عبور
	const updateUserPassword = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/UpdateUserPassword", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت نقش کاربر
	const queryUserRoles = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryUserRoles", type: "GET" });
		return response ? response.Result : null;
	};

	return {
		createApiTokenBySession,
		login,
		queryTaxPercent,
		accessAsanWallet,
		sendOTPCodeAsync,
		resendOTPCode,
		confirmOTPCode,
		queryCurrentUser,
		resetPassword,
		queryGender,
		queryActiveProvince,
		queryCityByCityId,
		queryActiveCityByProvinceId,
		addDocument,
		queryWalletType,
		queryOTPIsRequired,
		querySimSwapReason,
		queryCertType,
		queryActiveCountry,
		queryActiveLanguage,
		getDocument,
		queryMinimumAmountGetCashFromWallet,
		withdrawUserWallet,
		refreshToken,
		updateUserPassword,
		queryUserRoles,
	};
};
export const useDealer = () => {
	//در یافت باندل براساس کیت
	const queryBundleSalesSimByKit = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimByKit", parameters: parameters });
		return response ? response.Result : null;
	};

	const queryBundleSalesSimById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimById", parameters: parameters });
		return response ? response.Result : null;
	};
	const queryBundleSalesSimByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimByMSISDN", parameters: parameters });
		return response ? response.Result : null;
	};
	const queryMSISDNByBundleSalesSimId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/MSISDN/QueryMSISDNByBundleSalesSimId", parameters: parameters });
		return response ? response : null;
	};
	const validateKitNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/ValidateKitNo", parameters: parameters });
		return response ? response.Result : null;
	};
	const reserveKitNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/ReserveKitNo", parameters: parameters });
		return response ? response : null;
	};
	const reserveMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/MSISDN/ReserveMSISDN", parameters: parameters });
		return response ? response : null;
	};
	// دریافت پروفایل براساس کد ملی و تاریخ تولد
	const queryProfileByCertNoVBirthDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/QueryProfileByCertNoVBirthDate", parameters: parameters });
		return response ? response.Result : null;
	};
	// دریافت تعداد سیم کارت فعال
	const queryCountSimCardByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/QueryCountSimCardByCertNo", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت اطلاعات پستی
	const addressByPostcode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddressByPostcode", parameters: parameters });
		return response ? response.Result : null;
	};
	// ارسال پروفایل مشترک
	const addProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddProfile", parameters: parameters });
		return response ? response.Result : null;
	};
	//ارسال آدرس پروفایل
	const addAddress = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddAddress", parameters: parameters });
		return response ? response : null;
	};
	//روش ارسال سیم کارت
	const queryMethodOfReceiptByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/QueryMethodOfReceiptByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت کمیسیون تعویض سیم کارت
	const calculateSWCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CalculateSWCommissionPrice", parameters: parameters });
		return response ? response.Result : null;
	};
	//محاسبه کمیسیون
	const calculateSPCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CalculateSPCommissionPrice", parameters: parameters });
		return response ? response.Result : null;
	};
	//بررسی صحیح بودن کد تخفیف
	const isValidDiscountCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Discount/IsValidDiscountCode", parameters: parameters });
		return response ? response : null;
	};
	//دریافت کد تخفیف
	const queryDiscountCodeByCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Discount/QueryDiscountCodeByCode", parameters: parameters });
		return response ? response.Result : null;
	};

	//فعال سازی سیم کارت
	const redirectToNeginWalletGateWay = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/RedirectToNeginWalletGateWay", parameters: parameters });
		return response ? response.Result : null;
	};
	//اپلود سند خرید سیم کارت
	const updateDocumentSPPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Document/UpdateDocumentSPPurchase", parameters: parameters });
		return response ? response : null;
	};
	//اپلود سند خرید سیم کارت
	const updateDocumentSPPurchaseWithAddDoc = async (parameters, doctype, sppurchaseid) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/Document/UpdateDocumentSPPurchaseWithAddDoc?doctype=${doctype}&sppurchaseid=${sppurchaseid}`,
			parameters: parameters,
			contentType: "multipart/form-data",
		});
		return response ? response : null;
	};
	//بررسی کیت برای تعویض
	const checkKitNOForSW = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/CheckKitNOForSW", parameters: parameters });
		return response ? response : null;
	};

	//دریافت پیش فاکتور تعویض
	const sWPreFactor = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/SWPreFactor", parameters: parameters });
		return response ? response.Result : null;
	};

	//تعویض سیم کارت
	const simSwap = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/CompletePurchase/SimSwap", parameters: parameters });
		return response ? response.Result : null;
	};

	//لیست مقادیر شارژ
	const queryValidChargeByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryValidChargeByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	//بررسی شماره برای خرید شارژ
	const isValidMSISDNToBuyCharge = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Subscription/IsValidMSISDNToBuyCharge", parameters: parameters });
		return response ? response.Result : null;
	};

	const isValidMSISDNToChangeOwner = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Subscription/IsValidMSISDNToChangeOwner", parameters: parameters });
		return response ? response : null;
	};
	const completeDCPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CompleteDCPurchase", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت لیست بسته ها از طریق شماره
	const queryPackage = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryPackage", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت گروه های فیلتر بسته ها
	const queryProductGroup = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryProductGroup", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت بسته ها براساس گروه بندی
	const queryPackagesBySubGroup = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryPackagesBySubGroup", parameters: parameters });
		return response ? response.Result : null;
	};
	//سرویس خرید و فعالسازی بسته
	const completeEPPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CompleteEPPurchase", parameters: parameters });
		return response ? response.Result : null;
	};

	//لیست مدارک ارسال نشده خرید سیم کارت
	const querySPPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByState", parameters: parameters });
		return response ? response : null;
	};

	//دریافت وضعیت خرید سیم کارت
	const queryLogChangeStatePurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryLogChangeStatePurchase?id=${parameters}`, type: "get" });
		return response ? response.Result : null;
	};

	//دریافت جزییات خرید و پروفایل
	const querySPPurchaseVProfileDealerById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseVProfileDealerById?sppurchaseid=${parameters}`, type: "get" });
		return response ? response.Result : null;
	};

	//دریافت لیست تحویل سیم کارت فرودگاه
	const querySPPurchaseByMethodOfReceipt = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseByMethodOfReceipt`, parameters: parameters });
		return response ? response?.Result?.Result : null;
	};

	//دریافت لیست تحویل سیم کارت فرودگاه
	const querySPPurchaseByMethodOfReceiptList = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseByMethodOfReceiptList`, parameters: parameters });
		return response ? response?.Result?.Result : null;
	};

	//دریافت اطلاعات پیش فاکتور تغییر مالکیت
	const changeOwnerPreFactor = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/PaymentInfo/ChangeOwnerPreFactor`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//تغییر مالکیت سیم کارت
	const changeOwner = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/CompletePurchase/ChangeOwner`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//تغییر مالکیت حقوقی
	const changeOwnerB2B = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/CompletePurchase/ChangeOwnerB2B`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//لیست جستجوی کیف پول
	const queryWalletByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryWalletByDate`, parameters: parameters });
		return response ? response : null;
	};

	//بررسی امکان تعویض سیم کارت
	const isValidMSISDNToSimSwap = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/IsValidMSISDNToSimSwap`, parameters: parameters });
		return response ? response : null;
	};

	//ارسال پروفایل به همراه فایل تصویر کارت شناسایی
	const addProfileWithDoc = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/AddProfileWithDoc`, parameters: parameters, contentType: "multipart/form-data" });
		return response ? response?.Result : null;
	};

	//اپدیت مدرک پروفایل مشترک
	const updateDocumentProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/UpdateDocumentProfile`, parameters: parameters });
		return response ? response : null;
	};

	//اپدیت مدرک پروفایل مشترک
	const updateDocumentSPPurchaseVProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSPPurchaseVProfile`, parameters: parameters });
		return response ? response : null;
	};

	//گزارش فروش
	const querySPPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySPPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش تغییر مالکیت
	const queryCoPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryCoPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش تعویض سیم کارت
	const querySWPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش فروش شارژ
	const queryDCPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDCPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش فروش بسته
	const queryEPPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryEPPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//درانتظار آپلود مدارک تغییرمالکیت
	const queryCOPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryCOPurchaseDealerByState`, parameters: parameters });
		return response ? response : null;
	};
	//اپدیت مدارک تغییرمالکیت
	const updateDocumentCOPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentCOPurchase`, parameters: parameters });
		return response ? response : null;
	};
	//درانتظار آپلود مدارک تعویض سیمکارت
	const querySWPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseDealerByState`, parameters: parameters });
		return response ? response : null;
	};
	//اپدیت مدارک تعویض سیمکارت
	const updateDocumentSWPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSWPurchase`, parameters: parameters });
		return response ? response : null;
	};

	//لیست گروه های اطلاع رسانی
	const queryAnnouncementGroupByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/QueryAnnouncementGroupByPlanId`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//لیست گروه های اطلاع رسانی
	const queryAnnouncementDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/QueryAnnouncementDealerByState`, parameters: parameters });
		return response ? response : null;
	};

	//علامت خواندن برای notification
	const createAnnouncementsVUser = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/CreateAnnouncementsVUser`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//جزییات شارژ کیف پول
	const queryDetailOfChangeWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDetailOfChangeWallet`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//تغییر سیم کارت
	const updateDocumentSWPurchaseVProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSWPurchaseVProfile`, parameters: parameters });
		return response ? response : null;
	};

	//کمیسیون تغییرمالکیت
	const calculateCOCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/PaymentInfo/CalculateCOCommissionPrice`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//1)چک کردن مطابقت شماره موایل و کد ملی در حداول خودمون
	const validateMSISDNVCertNO = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/ValidateMSISDNVCertNO`, parameters: parameters });
		return response ? response : null;
	};

	const queryCountActiveSPPurchaseByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/QueryCountActiveSPPurchaseByCertNo`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const queryActiveSPPurchaseByCertNoVMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryActiveSPPurchaseByCertNoVMSISDN`, parameters: parameters });
		return response ? response : null;
	};

	const queryIMEI = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryIMEI`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const queryMSISDNVICCIDBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryMSISDNVICCIDBySPPurchaseId?sppurchaseid=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};
	const querySPPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseBySPPurchaseId?sppurchaseid=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};
	const queryProfileSPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/Subscription/QueryProfileSPurchaseBySPPurchaseId?sppurchaseid=${parameters}`,
			parameters,
			type: "get",
		});
		return response ? response?.Result : null;
	};

	const queryActivatedProductsMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryActivatedProductsMSISDN?msisdn=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};

	const queryDCPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDCPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	const queryEPPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryEPPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	const querySWPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	//سهم از فروش
	const queryRevenueShareByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryRevenueShareByDate`, parameters: parameters });
		return response ? response : null;
	};

	const queryBalance = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryBalance?msisdn=${parameters}`, type: "get" });
		return response ? response?.Result : null;
	};
	const queryFirstActivationDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryFirstActivationDate?msisdn=${parameters}`, type: "get" });
		return response ? response?.Result : null;
	};

	const queryHotBill = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Billing/QueryHotBill`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const callBackBillingToNeginWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Billing/CallBackBillingToNeginWallet`, parameters: parameters });
		return response ? response?.Result : null;
	};
	const queryMSCAddress = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryMSCAddress`, parameters: parameters });
		return response ? response?.Result : null;
	};
	const updateMobileNetwork = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/UpdateMobileNetwork`, parameters: parameters });
		return response ? response : null;
	};

	const queryBankCardProfileByCertNo = async (parameters, signal) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/QueryBankCardProfileByCertNo`, parameters: parameters, signal });
		return response ? response : null;
	};

	return {
		queryBundleSalesSimByKit,
		queryBundleSalesSimById,
		queryBundleSalesSimByMSISDN,
		queryMSISDNByBundleSalesSimId,
		validateKitNo,
		reserveKitNo,
		reserveMSISDN,
		queryProfileByCertNoVBirthDate,
		queryCountSimCardByCertNo,
		addressByPostcode,
		addProfile,
		addAddress,
		queryMethodOfReceiptByPlanId,
		calculateSWCommissionPrice,
		calculateSPCommissionPrice,
		isValidDiscountCode,
		queryDiscountCodeByCode,
		redirectToNeginWalletGateWay,
		updateDocumentSPPurchase,
		updateDocumentSPPurchaseWithAddDoc,
		checkKitNOForSW,
		sWPreFactor,
		simSwap,
		queryValidChargeByPlanId,
		isValidMSISDNToBuyCharge,
		completeDCPurchase,
		queryPackage,
		queryProductGroup,
		queryPackagesBySubGroup,
		completeEPPurchase,
		querySPPurchaseDealerByState,
		queryLogChangeStatePurchase,
		querySPPurchaseVProfileDealerById,
		querySPPurchaseByMethodOfReceipt,
		changeOwnerPreFactor,
		changeOwner,
		changeOwnerB2B,
		queryWalletByDate,
		isValidMSISDNToSimSwap,
		addProfileWithDoc,
		querySPPurchaseDealerByDate,
		updateDocumentProfile,
		updateDocumentSPPurchaseVProfile,
		queryCoPurchaseDealerByDate,
		querySWPurchaseDealerByDate,
		queryDCPurchaseDealerByDate,
		queryEPPurchaseDealerByDate,
		queryCOPurchaseDealerByState,
		updateDocumentCOPurchase,
		querySWPurchaseDealerByState,
		updateDocumentSWPurchase,
		queryAnnouncementGroupByPlanId,
		queryAnnouncementDealerByState,
		queryDetailOfChangeWallet,
		updateDocumentSWPurchaseVProfile,
		calculateCOCommissionPrice,
		createAnnouncementsVUser,
		querySPPurchaseByMethodOfReceiptList,
		validateMSISDNVCertNO,
		queryCountActiveSPPurchaseByCertNo,
		queryActiveSPPurchaseByCertNoVMSISDN,
		queryMSISDNVICCIDBySPPurchaseId,
		querySPPurchaseBySPPurchaseId,
		queryProfileSPurchaseBySPPurchaseId,
		queryActivatedProductsMSISDN,
		queryDCPurchaseBySPPurchaseId,
		queryEPPurchaseBySPPurchaseId,
		querySWPurchaseBySPPurchaseId,
		queryRevenueShareByDate,
		queryBalance,
		queryFirstActivationDate,
		isValidMSISDNToChangeOwner,
		queryHotBill,
		callBackBillingToNeginWallet,
		queryMSCAddress,
		updateMobileNetwork,
		queryBankCardProfileByCertNo,
		queryIMEI,
	};
};
export const useSecurity = () => {
	// افزایش اعتبار کیف پول
	const increaseWalletByBankGateWay = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/IncreaseWalletByBankGateWay", parameters: parameters });
		return response ? response.Result : null;
	};
	//برگشت از بانک آسان پرداخت
	const callBackIPGAsanPardakht = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackIPGAsanPardakht", parameters: parameters });
		return response ? response : null;
	};
	//برگشت از بانک پارسیان
	const callBackIPGParsian = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackIPGParsian", parameters: parameters });
		return response ? response.Result : null;
	};
	// دریافت لیست درگاه ها
	const queryGateWayByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryGateWayByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	const callBackPOSAsanPardakht = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackPOSAsanPardakht", parameters: parameters });
		return response ? response : null;
	};

	return {
		increaseWalletByBankGateWay,
		callBackIPGAsanPardakht,
		callBackIPGParsian,
		queryGateWayByPlanId,
		callBackPOSAsanPardakht,
	};
};

export const useBaseInfo = () => {
	const queryOperators = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryOperators", type: "GET" });
		return response ? response : null;
	};

	return { queryOperators };
};

export const useAPIFile = () => {
	const convertDCFileToJson = async (request) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/FileManager/ConvertDCFileToJson", parameters: request, contentType: "multipart/form-data" });
		return response ? response?.Result : null;
	};
	const completeDCPurchase = async (request) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CompleteDCPurchase", parameters: request });
		return response ? response : null;
	};

	return { convertDCFileToJson, completeDCPurchase };
};

export const useCrm = () => {
	const querySPPurchasePerCustomerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/Subscription/QuerySPPurchasePerCustomerByState", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchaseByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/Subscription/QuerySPPurchaseByState", parameters: parameters });
		return response ? response : null;
	};

	const updateSPPurchaseFromPostToPrintDocState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPostToPrintDocState", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchasePrintDocState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintDocState", parameters: parameters });
		return response ? response : null;
	};
	const updateSPPurchaseFromPrintDocToPrintBarcodeState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPrintDocToPrintBarcodeState", parameters: parameters });
		return response ? response.Result : null;
	};
	const querySPPurchasePrintBarcodeState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintBarcodeState", parameters: parameters });
		return response ? response : null;
	};
	const updateSPPurchaseFromPrintBarcodeToFinalState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPrintBarcodeToFinalState", parameters: parameters });
		return response ? response.Result : null;
	};
	const querySPPurchasePrintBarcodeStateById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintBarcodeStateById", parameters: parameters });
		return response ? response.Result : null;
	};
	return {
		querySPPurchasePerCustomerByState,
		updateSPPurchaseFromPostToPrintDocState,
		querySPPurchasePrintDocState,
		updateSPPurchaseFromPrintDocToPrintBarcodeState,
		querySPPurchasePrintBarcodeState,
		updateSPPurchaseFromPrintBarcodeToFinalState,
		querySPPurchasePrintBarcodeStateById,
		querySPPurchaseByState,
	};
};

export const useReport = () => {
	const sPSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const ePSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/EPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const dCSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/DCSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportDCProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportDCProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportEPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportEPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportSPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportSPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportProductCommissionSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportProductCommissionSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const swSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SWSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const coSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/COSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const querySPPurchaseDealerByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByCertNo", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchaseDealerByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByMSISDN", parameters: parameters });
		return response ? response : null;
	};
	return {
		swSalesPerState,
		coSalesPerState,
		sPSalesPerState,
		ePSalesPerState,
		dCSalesPerState,
		statisticalReportDCProductCountSales,
		statisticalReportEPProductCountSales,
		statisticalReportSPProductCountSales,
		statisticalReportProductCommissionSales,
		querySPPurchaseDealerByCertNo,
		querySPPurchaseDealerByMSISDN,
	};
};
